// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7594451c","455":"b39f7469","977":"339f9bdc"}[chunkId] + ".chunk.js";
};